import type { SVGProps } from "react";
// generated from ArrowDown.svg — do not edit manually
// prettier-ignore
export default function ArrowDown(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M19 13L12 20M12 20L5 13M12 20V4" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
